import { useEffect } from 'react'

import useTeams from './useTeams'
interface HookOptionsProps {
  teamSuffix?: boolean
}
type UsePageTitleHook = (title: string, options?: HookOptionsProps) => void

const defaultOptions: HookOptionsProps = {
  teamSuffix: false,
}

const usePageTitle: UsePageTitleHook = (title: string, {
  teamSuffix,
}: HookOptionsProps = defaultOptions) => {
  const { currentTeam } = useTeams()
  useEffect(() => {
    if (teamSuffix) {
      document.title = currentTeam
        ? [title, currentTeam.name].join(' - ')
        : title
    }
    else {
      document.title = title
    }
  }, [title, teamSuffix, currentTeam])
}
export default usePageTitle
